export const themes = {
  default: {
    thRoot: 'isolate relative',
    thDatalist:
      'absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-lightGrey bg-white border-1 border-lightGrey divide-y divide-lightGrey  mt-20 p-10 rounded-12 shadow-lg top-full w-full z-10',
  },
};
